<template>
  <div class="d-flex flex-column">
    <subnav heading="Тарифы"/>

    <div class="flex-grow-1 position-relative">
      <div class="overflow-content">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <div class="tariffs container-fluid mt-3 mb-5">
            <div class="row">
              <div class="col-md" v-for="(tariff, index) in tariffs">
                <div class="tariffs-item card my-3" :class="{active: index === activeTariff}">
                  <div class="card-header text-center">
                      <!-- <div v-if="tariff.sale !== undefined" class="tariffs-sale">АКЦИЯ <span>{{tariff.sale}} ₽</span></div> -->
                    <h2 class="card-title tariffs-title display-4">{{tariff.title}}</h2>
                    <div class="tariffs-pricing">
                      <div class="tariffs-price">{{tariff.priceMonthly}} ₽</div>
                      в месяц
                      <div>или <span class="font-weight-bold">{{tariff.priceDaily}} ₽</span> в день за модем</div>
                    </div>
                  </div>
                  <div class="card-body row ml-0 mr-0">
                    <!-- Первый список с элементами из features[0] -->
                    <ul class="tariffs-features col-md-6 col-12">
                      <li
                        v-for="(f, index) in features[0]"
                        :key="index"
                        class="tariffs-features-item"
                        :class="{ inactive: index < 0, active: index >= 0 }"
                      >
                        <div class="tariffs-features-item-icon">
                          <font-awesome-icon icon="check-circle" />
                        </div>
                        {{ f }}
                      </li>
                    </ul>

                    <!-- Второй список с элементами из features[1] -->
                    <ul class="tariffs-features col-md-6 col-12">
                      <li
                        v-for="(f, index) in features[1]"
                        :key="index"
                        class="tariffs-features-item"
                        :class="{ inactive: index < 0, active: index >= 0 }"
                      >
                        <div class="tariffs-features-item-icon">
                          <font-awesome-icon icon="check-circle" />
                        </div>
                        {{ f }}
                      </li>
                    </ul>
                  </div>
                  <div class="card-footer text-center">
                    <button class="btn btn-outline-primary btn-lg btn-block active" v-if="tariff.code === activeTariff">Ваш тариф</button>
                    <button class="btn btn-outline-primary btn-lg btn-block" v-else @click="changeTariff(tariff.code)">Подписаться</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import api from '@/api'
  import moment from 'moment'

  export default {
    data () {
      return {
        tariffs: [
          {
            title: 'Максимальный',
            priceMonthly: 300,
            priceDaily: 9.86,
            code: 'maximal',
            sale: 400,
          },
        ],
        features: [
          [
            'Дашборд со сводной статистикой',
            'Список торговых автоматов',
            'Список уведомлений',
            'Настройка расписания снятия отчётов',
            'Настройка уведомлений',
            'Добавление пользователей организации',
            'Заявки на ингредиенты',
            'Расширенная информация по чекам',
            'Интеграция с терминалами Vendista, Vendotek, aQsi Cube',
          ],
          [
            'Отчёт о продажах',
            'Отчёт о событиях',
            'Отчёт о простоях',
            'Отчёт об инкассациях',
            'Отчёт о фискальных чеках',
            'Отчёт о расходе продуктов',
            'Управление пороговыми значениями',
            'Управление документами и чек-листами',
            'Управление продуктами и ингредиентами',
            'Управление обслуживанием торговых автоматов',
          ],
        ],
      }
    },
    computed: {
      date () {
        return moment().zone('+03:00').add(1, 'days').format('DD.MM.YYYY')
      },
    },
    methods: {
      changeTariff (code) {
        api.put(`regions/${this.$root.user.region_id}`, {subscription: code})
          .then((data) => {
            this.activeTariff = code
            window.alert(`Внимание! Новые настройки вступят в силу ${this.date}`)
          })
      },
    },
    asyncComputed: {
      activeTariff () {
        return api.get(`regions/${this.$root.user.region_id}`).then(({data}) => data.subscription)
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .tariffs {
    max-width: 1100px;
  }
  .tariffs-item {
    $bs: 0 1px 2px rgba(#000, .2);
    $active-bs: 0 12px 25px -4px rgba(#000, .15);
    border: none;
    box-shadow: $bs;
    transition: box-shadow .2s, border .2s;
    &.active {
      box-shadow: $active-bs, 0 0 0 2px $primary, 0 0 0 6px rgba($primary, .2);
      border-top-color: transparent;
      //.card-header,
      .card-footer {
        border-color: transparent;
      }
    }
    &:not(.active):hover {
      box-shadow: $active-bs, $bs;
    }
    .card-header {
      padding: 1.3rem;
      background-color: transparent;
    }
    .card-footer {
      padding-bottom: $card-spacer-x;
      border: none;
      background-color: transparent;
      @include gradient-y(rgba(#fff, 0), rgba($primary, .03));
    }
  }
  .tariffs-title {
  }
  .tariffs-sale {
    background-color: #b51f1f;
    color: white;
    padding: 8px;
    border-radius: 24px;
    text-shadow: 0 1px 0 #000;
        font-size: 2em;
    line-height: 1.1;
    margin-bottom: 0;
    font-weight: 600;
    letter-spacing: -.03em;
  }
  .tariffs-sale span {
    position: relative;
	  text-decoration: none;
  }
  .tariffs-sale span::before {
    content: '';
    border-bottom: 3px solid #000;
    box-shadow: 0 1px 2px rgba(234,0,0,0.63), 0 1px 2px rgba(234,0,0,0.63);
    position: absolute;
    width: 100%;
    height: 50%;
    transform: rotate(-12deg);
  }
  .tariffs-pricing {
  }
  .tariffs-price {
    font-size: 2.4em;
    line-height: 1.1;
    margin-bottom: 0;
    //font-weight: $font-weight-bolder;
    font-weight: 600;
    letter-spacing: -.03em;
  }
  .tariffs-features {
    margin: 0;
    padding: 0;
    list-style: none none;
  }
  $tariffs-features-padding-left: 1.5rem;
  .tariffs-features-item {
    margin: .3rem 0;
    padding-left: $tariffs-features-padding-left;
    &.active {
      .tariffs-features-item-icon {
        color: $success;
      }
    }
    &.inactive {
      color: $gray-500;
    }
  }
  .tariffs-features-item-icon {
    float: left;
    margin-left: -$tariffs-features-padding-left;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/tariffs.vue